import React, { useContext, useMemo, useState } from 'react';
import classNames from 'classnames';
import { IMetaResource } from '@enuan/chat__utils';
import { instanceContext } from '../../../../contexts/instance';
import { Download } from './Download';
import { Details } from '../../../message/content';
import { ImageSize } from '../../../message/content/Image';
import { Time } from '../../../message/Time';
import { SettingsIcon } from 'src/components/Icons/SettingsIcon';
import { CloseIcon } from 'src/components/Icons/CloseIcon';

export const ImageBalloonContent = ({
	data,
	timestamp,
}: {
	data: IMetaResource;
	timestamp?: string | number;
}) => {
	const { name } = data;

	const { instance: provider } = useContext(instanceContext);
	const url = useMemo(() => provider?.getResourceUrl(data), [data, provider]);

	const [ref, setRef] = useState<HTMLImageElement | null>(null);

	return (
		<div className="balloon__frame">
			<InlineDetails
				data={data}
				width={ref?.naturalWidth}
				height={ref?.naturalHeight}
			/>
			<figure className="message__image">
				<img src={url} alt={name} onLoad={(ev) => setRef(ev.currentTarget)} />
			</figure>
			<Time timestamp={timestamp} />
		</div>
	);
};

const InlineDetails = ({
	data,
	width,
	height,
}: {
	data: IMetaResource;
	width?: number;
	height?: number;
}) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={classNames('details', isOpen && 'details--open')}>
			<button type="button" className="open" onClick={() => setIsOpen(true)}>
				<SettingsIcon />
			</button>
			<Download data={data} />
			<Details
				resource={data}
				description={
					width && height && <ImageSize width={width} height={height} />
				}
			/>
			<button type="button" className="close" onClick={() => setIsOpen(false)}>
				<CloseIcon />
			</button>
		</div>
	);
};
